import { render, staticRenderFns } from "./ItemOnlyText.vue?vue&type=template&id=1650589c&scoped=true&"
import script from "./ItemOnlyText.vue?vue&type=script&lang=js&"
export * from "./ItemOnlyText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1650589c",
  null
  
)

export default component.exports